import React, { useState } from "react";
import ReactECharts from "echarts-for-react";
import { Card } from "primereact/card";
const calculatePercentage = (value, total) => {
  return value;
  // return parseFloat((value / total) * 100).toFixed(2) + "%";
};

const DoughnutChart = ({ data, onRefresh  }) => {
  const totalEmployees = { ...data[0] };
  const totalAcknowledged = { ...data[1] };
  const totalPending = { ...data[2] };

  totalEmployees.name = "Total Handbooks " + totalEmployees.value;
  totalPending.name = "Total Pending " + calculatePercentage(totalPending.value, totalEmployees.value);
  totalAcknowledged.name = "Total Acknowledged " + calculatePercentage(totalAcknowledged.value, totalEmployees.value);

  // Exclude totalEmployees from the dataChart array for the pie chart
  const dataChart = [totalAcknowledged, totalPending];

  const option = {
    // ... Rest of the option object remains unchanged ...
    title: {
      text: 'Employees Acknowledged',
    },
    legend: {
      orient: "vertical",
      right: 0,
      textStyle: {
        fontSize: 12,
      },
      bottom: 0,
      data: [totalEmployees,totalAcknowledged,totalPending], // Include totalEmployees in the legend only
    },

    series: [
      {
        name: "Employees Acknowledged",
        type: "pie",
        radius: ["35%", "49%"],
        color: ["#FFF301", "#145EFC", "#24B24E"],
        label: {
          show: true,
          fontSize: 12,
         
        },
        center: ["38%", "50%"],
        itemStyle: {
          emphasis: {
            shadowBlur: 5,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.2)",
          },
        },
        data: dataChart, // Use the modified dataChart array
      },
    ],
  };

  const [count, setCount] = useState(0);

  function onChartReady(echarts) {
    console.log("echarts is ready", echarts);
  }

  function onChartClick(param, echarts) {
    console.log(param, echarts);
    // debugger;
    setCount(count + 1);
  }

  function onChartLegendselectchanged(param, echarts) {
    console.log(param, echarts);
  }

  function onClickRestore(param, echarts) {
    console.log(param, echarts);
    onRefresh();
  }

  return (
    <>
      <Card>
      <div className="absolute bottom-[5.7rem] text-[#333] right-10 pr-[2px] text-[14px] "><b>Total Handbooks {totalEmployees.value}</b></div> 
        {dataChart && (
          <ReactECharts
            option={option}
            style={{ height: 250 }}
            onChartReady={onChartReady}
            showLoading={!data.length}
            onEvents={{
              click: onChartClick,
              legendselectchanged: onChartLegendselectchanged,
              restore: onClickRestore
            }}
          />
        )}
      </Card>
    </>
  );
};



export default DoughnutChart;
